/*
 app dependencies
 - var body

 lib dependencies
*/

const scOrganisationByPerson = (function($)
{
    //private
    const   _personSelect = document.querySelector('select.js-add-statement-person-input'),
            _organisationSelect = document.querySelector('select.js-add-statement-organisation-input');

	//module functions
	function init()
	{
		if (!_personSelect || !_organisationSelect) return;

        $(_personSelect).on('change', function(e)
        {
            if (parseInt(_personSelect.value) > 0)
            {
                doAjax({
                    ajaxUrl: '/ajax/get-organisation-id',
                    data: {
                        personId: _personSelect.value
                    },
                    onSuccess: _onLoadSuccess,
                    onError: _onLoadError
                });
            }
        });
	}

        function _onLoadSuccess(rawResponse, params)
        {
            try
            {
                var response = $.parseJSON(rawResponse);
                if (response.success)
                {
                    //prefill organisation select
                    if (response.organisationId) _organisationSelect.value = response.organisationId;
                    scUi.updateChosen($('.js-add-statement-form'));
                }
                else throw new Error(response.message);
            }
            catch (err) { alert(err.message); }
        }


        function _onLoadError(jqxhr, textStatus, errorThrown, params)
        {
            //error?
            if (!userAbortedAjax(jqxhr)) alert(errorThrown);
        }

    //reveal public vars and functions
	return {
		//vars
		//functions
		init
	};

})(jQuery);
